/* ==========================================================
   GF Floating Video Pro
   Core Module v1.0
   ========================================================== */

(function (window, document) {
  "use strict";

  const widget = document.getElementById("gfFloatingVideo");

  if (!widget) {
    return;
  }

  const overlay = document.getElementById("gfVideoOverlay");
  const player = document.getElementById("gfVideoPlayer");
  const closeButton = document.getElementById("gfCloseVideo");
  const thumbnail = document.getElementById("gfThumbnail");

  const data = window.GF_VIDEO || {};

  const videoUrl = (data.url || "").trim();

  const GF = {

    widget: widget,
    overlay: overlay,
    player: player,
    closeButton: closeButton,
    thumbnail: thumbnail,

    videoUrl: videoUrl,

    videoType: "",

    embedUrl: "",

    isOpen: false

  };



  function detectVideoType(url){

    if(!url) return "";

    const lower=url.toLowerCase();



    if(lower.includes("youtube.com/shorts/")){

      return "youtube-shorts";

    }



    if(lower.includes("youtube.com/watch")){

      return "youtube";

    }



    if(lower.includes("youtu.be/")){

      return "youtube";

    }



    if(lower.includes("vimeo.com/")){

      return "vimeo";

    }



    if(

      lower.includes(".mp4") ||

      lower.includes("/videos/")

    ){

      return "mp4";

    }



    return "unknown";

  }



  GF.videoType=detectVideoType(videoUrl);



  function youtubeId(url){

    try{

      if(url.includes("/shorts/")){

        return url.split("/shorts/")[1].split("?")[0];

      }



      if(url.includes("watch?v=")){

        return url.split("watch?v=")[1].split("&")[0];

      }



      if(url.includes("youtu.be/")){

        return url.split("youtu.be/")[1].split("?")[0];

      }

    }

    catch(e){}



    return "";

  }



  GF.youtubeId=youtubeId(videoUrl);



  function buildEmbedUrl(){

    switch(GF.videoType){

      case "youtube":

      case "youtube-shorts":

        if(!GF.youtubeId) return "";



        return "https://www.youtube.com/embed/"

        +GF.youtubeId+

        "?autoplay=1&mute=1&playsinline=1&rel=0";



      case "mp4":

        return GF.videoUrl;



      case "vimeo":

        return GF.videoUrl;



      default:

        return "";

    }

  }



  GF.embedUrl=buildEmbedUrl();



  window.GFVideo=GF;



  console.log(

    "[GF Video] Core Loaded",

    GF

  );



})(window,document);

/*=========================================================
GF CORE
Part 2
=========================================================*/

(function(window){

"use strict";

const GF = window.GFVideo;

if(!GF) return;

GF.open = function(){

console.log("GF OPEN");

};

GF.close = function(){

console.log("GF CLOSE");

};

window.GFVideo = GF;

})(window);

/* ==========================================================
   GF Core Module
   Part 3 - Popup Controller
   ========================================================== */

(function (window, document) {
  "use strict";

  const GF = window.GFVideo;

  if (!GF) return;

  function clearPlayer() {
    if (GF.player) {
      GF.player.innerHTML = "";
    }
  }

  GF.open = function () {

    if (!GF.overlay) return;

    GF.isOpen = true;

    GF.overlay.classList.add("active");

    GF.overlay.setAttribute("aria-hidden", "false");

    document.documentElement.classList.add("gf-video-lock");
    document.body.classList.add("gf-video-lock");

    console.log("[GF Video] Popup Open");

  };

  GF.close = function () {

    if (!GF.overlay) return;

    GF.isOpen = false;

    GF.overlay.classList.remove("active");

    GF.overlay.setAttribute("aria-hidden", "true");

    document.documentElement.classList.remove("gf-video-lock");
    document.body.classList.remove("gf-video-lock");

    clearPlayer();

    console.log("[GF Video] Popup Closed");

  };

  const button = GF.widget.querySelector(".gf-floating__outer");

  if (button) {

    button.addEventListener("click", function (e) {

      e.preventDefault();

      GF.open();

    });

  }

  if (GF.closeButton) {

    GF.closeButton.addEventListener("click", function () {

      GF.close();

    });

  }

  if (GF.overlay) {

    GF.overlay.addEventListener("click", function (e) {

      if (e.target.classList.contains("gf-video-backdrop")) {

        GF.close();

      }

    });

  }

  document.addEventListener("keydown", function (e) {

    if (e.key === "Escape" && GF.isOpen) {

      GF.close();

    }

  });

})(window, document);

/* ==========================================================
   GF Core Module
   Part 4 - Video Player
   ========================================================== */

(function(window){

"use strict";

const GF = window.GFVideo;

if(!GF) return;

function buildPlayer(){

    if(!GF.player) return;

    GF.player.innerHTML="";

    if(GF.videoType==="youtube" || GF.videoType==="youtube-shorts"){

        GF.player.innerHTML=`
            <iframe
                src="${GF.embedUrl}"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                loading="lazy"
                referrerpolicy="strict-origin-when-cross-origin">
            </iframe>
        `;

        return;
    }

    if(GF.videoType==="mp4"){

        GF.player.innerHTML=`
            <video
                controls
                autoplay
                playsinline
                preload="metadata"
                style="width:100%;height:100%;">
                <source src="${GF.embedUrl}" type="video/mp4">
            </video>
        `;

        return;
    }

}

const oldOpen = GF.open;

GF.open = function(){

    oldOpen();

    buildPlayer();

};

window.GFVideo=GF;

})(window);

/* ==========================================================
   GF Thumbnail Engine
   Part 5
   ========================================================== */

(function(window){

"use strict";

const GF = window.GFVideo;

if(!GF) return;

if(!GF.thumbnail) return;

function youtubeThumbnail(id){

    return [

        "https://i.ytimg.com/vi/"+id+"/maxresdefault.jpg",

        "https://i.ytimg.com/vi/"+id+"/hqdefault.jpg"

    ];

}

function renderImage(src){

    const img=new Image();

    img.loading="lazy";

    img.decoding="async";

    img.alt="Product Video";

    img.style.width="100%";

    img.style.height="100%";

    img.style.objectFit="cover";

    img.style.borderRadius="50%";

    img.src=src;

    img.onerror=function(){

        if(src.indexOf("maxresdefault")>-1){

            this.src=src.replace("maxresdefault","hqdefault");

        }

    };

    GF.thumbnail.innerHTML="";

    GF.thumbnail.appendChild(img);

}

if(

GF.videoType==="youtube" ||

GF.videoType==="youtube-shorts"

){

    const list=youtubeThumbnail(GF.youtubeId);

    renderImage(list[0]);

}

})(window);

/* ==========================================================
GF AJAX CART
========================================================== */

(function(window){

const button=document.getElementById("gfAddToCart");

if(!button) return;

button.addEventListener("click",async function(){

const variant=document.querySelector('input[name="id"]:checked') ||
document.querySelector('input[name="id"]') ||
document.querySelector('select[name="id"]');

let variantId=button.dataset.variant;

if(variant){

variantId=variant.value;

}

button.classList.add("loading");

button.innerHTML="Adding...";

try{

const response=await fetch("/cart/add.js",{

method:"POST",

headers:{

"Content-Type":"application/json"

},

body:JSON.stringify({

id:variantId,

quantity:1

})

});

if(!response.ok){

throw new Error("Cart Error");

}

button.classList.remove("loading");

button.classList.add("success");

button.innerHTML="✓ Added to Cart";

document.dispatchEvent(new CustomEvent("cart:refresh"));

setTimeout(function(){

button.classList.remove("success");

button.innerHTML="🛒 Add to Cart";

/* Close popup */

if(window.GFVideo && typeof window.GFVideo.close==="function"){

window.GFVideo.close();

}

/* Open Ella Cart Drawer */

/* Open Ella Cart Drawer */

/* Open Ella Cart Drawer */

/* Open Ella Cart Drawer */

setTimeout(function(){

    if(typeof window.GFOpenCart==="function"){

        window.GFOpenCart();

    }

},300);

},1200);

}catch(e){

button.classList.remove("loading");

button.innerHTML="Try Again";

console.error(e);

}

});

})(window);

/* ===========================================================
GF MOBILE BUBBLE AUTO EXPAND
=========================================================== */

(function(){

    if(window.innerWidth > 768) return;

    const bubble=document.getElementById("gfFloatingVideo");

    if(!bubble) return;

    function cycle(){

        bubble.classList.add("gf-expand");

        setTimeout(function(){

            bubble.classList.remove("gf-expand");

        },2000);

    }

    setTimeout(cycle,2000);

    setInterval(cycle,10000);

})();

/* ===========================================================
GF MOBILE LABEL ANIMATION
=========================================================== */

(function(){

if(window.innerWidth>768) return;

const bubble=document.getElementById("gfFloatingVideo");

if(!bubble) return;

function show(){

bubble.classList.add("gf-show-label");

setTimeout(function(){

bubble.classList.remove("gf-show-label");

},2000);

}

setTimeout(show,2000);

setInterval(show,10000);

})();